import React from 'react'
import ElectronicTaxBureau from './index.js'

/** 授权旧版本 */
const ElectronicTaxBureauOld = (props) => {
  return <ElectronicTaxBureau NEW_AUTH={false} {...props} />
}

export default ElectronicTaxBureauOld